import type { PropsWithChildren } from 'react';
import { cn } from '../utils';

type Props = {
  className?: string;
  childrenClassName?: string;
};

const Separator = ({
  className,
  childrenClassName,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <div
      className={cn(
        'w-full h-[0.2rem] bg-secondary-bg flex items-center justify-end pr-[2.6rem] my-[0.7rem]',
        className
      )}>
      {children && (
        <div className={cn('px-[0.8rem]', childrenClassName)}>{children}</div>
      )}
    </div>
  );
};

export { Separator };
